import { styled } from 'styled-components';

export const HeaderContent = styled.header`
  position: fixed;
  width: 100%;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
  background: #fff;

  @media (max-width: 767px) {
    height: auto;
    min-height: 56px;
    padding: 8px 12px;
    gap: 8px;
    flex-wrap: nowrap;
    justify-content: space-between;
    overflow: hidden;
  }
`;
